var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticStyle:{"border-bottom":"1px #d9d9d9 solid","overflow":"hidden","background":"#EAECF2","padding":"4px 4px 0 4px"}},[_c('img',{staticClass:"h-100 w-100",class:_vm.isImage(_vm.type) ? 'image' : 'more',attrs:{"loading":"lazy","src":_vm.isImage(_vm.type) ? _vm.url : _vm.getFileThumb(_vm.id)}})])
}
var staticRenderFns = []

export { render, staticRenderFns }